import ContractTerms from './ContractTerms.component';

export default ContractTerms;